<h1>PDF manipulation</h1>

<app-tabs>
  <app-tab-item>
    <ng-template>
      <span>Single Pdf</span>
    </ng-template>
    <label for="input_pdf">Select PDF</label>
    <input
      accept="application/pdf"
      id="input_pdf"
      name="input_pdf"
      type="file"
      (change)="onSingleFileSelected($event)"
    /><br />
    <h2>Actions</h2>
    <app-tabs>
      <app-tab-item>
        <ng-template>
          <span>Split</span>
        </ng-template>

        <div>
          <input
            id="enableSplit"
            name="split"
            type="checkbox"
            [(ngModel)]="enabledSplit"
          />
          <label for="enableSplit">Enabled</label>
        </div>
        <div [hidden]="!enabledSplit()">
          <div>
            <input id="splitEachPage" name="split" type="radio" />
            <label for="splitEachPage">Each page</label>
          </div>
          <div>
            <input id="splitOddPages" name="split" type="radio" />
            <label for="splitOddPages">Odd pages</label>
          </div>
          <div>
            <input id="splitEvenPages" name="split" type="radio" />
            <label for="splitEvenPages">Even pages</label>
          </div>
        </div>

        <button type="button" (click)="split()">Each page</button>
      </app-tab-item>
      <app-tab-item>
        <ng-template>
          <span>Compress</span>
        </ng-template>
        <button type="button" (click)="compress()">Compress</button><br />
      </app-tab-item>
    </app-tabs>
    <h3>Various</h3>
    <button type="button" (click)="pageCount()">Show</button>
    <h3>Split</h3>
    <p>{{ this.status() }}</p>
    <h3>Result</h3>
    <button type="button" [class]="downloadVisilibity()" (click)="download()">
      Télécharger
    </button>

    @for (url of generatedPageUrls(); track $index) {
      @if (url) {
        <img [alt]="`Page ${$index + 1}`" [src]="url" />
      } @else {
        <div class="loader">Loading page {{ $index + 1 }}...</div>
      }
    }
  </app-tab-item>
</app-tabs>

@if (isLoading()) {
  <app-spinner-loading [size]="spinnerSize()" [title]="titleLoading" />
}

<a href="https://github.com/bansan85/web-demangler">
  <app-github-mark-inline class="github_logo" />
</a>
